<template>
  <div class="tenders-toolbar-filter">
    <OrganizationReportsDialog
      v-if="growthBook.useOrganizationReports"
      data-qa="organization-reports"
      :disabled="loading"
      :filters="flatFilters"/>
    <DownloadTendersToExcel
      data-qa="export-to-excel"
      :disabled="loading"
      :filtred_count="itemCount"
      :search="flatFilters"/>
    <FiltersBlockTenders
      ref="FiltersBlock"
      :available-filters="filter_items"
      :filters="filters"
      @applyFilters="applyFilters">
      <template #third_activator="{ item, disabled }">
        <TenderFiters
          :key="`tender-fiters-${item.id}`"
          :disabled="disabled"
          :item="item"
          @update:item="updateFilterValue"/>
      </template>
    </FiltersBlockTenders>
    <SearchInput
      class="mr-2"
      debounce
      :disabled="loading"
      :search="phrase"
      @applySearch="updatePhrase"
      @update:search="removeSharp"/>
    <ModeButtons
      :disabled="loading"
      :mode.sync="tableModeComputed"/>
  </div>
</template>
<script>
import SearchInput from 'components/common/inputs/SearchInput.vue'
import FiltersBlockTenders from 'components/common/blocks/FiltersBlockTenders.vue'
import ModeButtons from 'components/common/elements/ModeButtons.vue'
import TenderFiters from 'components/tenders/all tenders/TenderFiters.vue'
import DownloadTendersToExcel from 'components/tenders/dialogs/DownloadTendersToExcel.vue'
import OrganizationReportsDialog from 'components/tenders/dialogs/OrganizationReportsDialog.vue'

import { mapGetters } from 'vuex'
import functionMixin from 'mixins/functionMixin'
import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'tendersToolbarFilter',
  mixins: [ functionMixin, godModeMixin ],
  data() {
    return {
      phrase: ''
    }
  },
  methods: {
    updateFilterValue(value) {
      if (!value.search?.length) {
        return
      }
      const result = this.$_.cloneDeep(this.filters)

      if (!result?.tenderSearchParam) {
        return
      }
      const dateFilters = ['dateAdded', 'tenderingEndDate', 'publication', 'contractDate']
      const sprFilter = ['categoryIds','biddingTypeCodes','tenderStatuses', 'departmentIds', 'contactIds',
        'tariffUserIds', 'contactPersonDepartment', 'organizationIds', ]
      const getValue = (filterValue) => {
        if (dateFilters.includes(filterValue.type)) {
          return {
            from: filterValue.search[0],
            to: filterValue.search[1],
          }
        } else if (sprFilter.includes(filterValue.type)) {
          const result = []
          const isClassifications = filterValue.search[0] !== null && typeof filterValue.search[0] === 'object'

          let valueItem = filterValue.search
          if (isClassifications) {
            valueItem = filterValue.search.map(el => el.classificationCode)
            this.$_savePropToDBStorage('tenders_classification_filters', filterValue.search)
          }
          result.push(...valueItem)
          return result
        }
        return value.search
      }

      let methodFilter = value.contain ? 'containsFilter' : 'notContainFilter'

      result.tenderSearchParam[methodFilter] ||= {}
      result.tenderSearchParam[methodFilter][value.type] = getValue(value)

      const hasChange = this.$_compareObjects(
        result.tenderSearchParam[methodFilter][value.type],
        this.filters?.tenderSearchParam?.[methodFilter]?.[value?.type]
      )

      if (hasChange.length) {
        this.$root.$emit('setActiveTemplateFilters', null)
      }

      this.$emit('update:filters', result)
    },
    bigFirstLetter(element) {
      return (element[0]?.toUpperCase() || '') + element?.slice(1)?.toLowerCase() || ''
    },
    applyFilters({filters, mode}) {
      const result = this.$_.cloneDeep(this.filters)
      let getFilter = items => {
        let result = {}
        items.forEach((filter) => {
          switch (filter.type) {
          case 'tenderStatuses':
          case 'departmentIds':
          case 'contactIds':
          case 'tariffUserIds':
          case 'contactPersonDepartment':
          case 'biddingTypeCodes':
          case 'organizationIds':
          case 'categoryIds':  {
            const conditions = filter.search[0] !== null && typeof filter.search[0] === 'object'
            result[filter.type] ||= []
            let value = conditions ? filter.search.map(el => el.classificationCode) : filter.search
            result[filter.type].push(...value)
            break
          }
          case 'publication':
          case 'dateAdded':
          case 'contractDate':
          case 'tenderingEndDate': {
            result[filter.type] = {
              from: filter.search[0],
              to: filter.search[1],
            }
            break
          }
          }
        })
        return result
      }
      let containsFilter = {}
      let notContainFilter = {}
      Object.entries(this.$_.groupBy(filters, 'contain')).forEach(([name, items]) => {
        let filter = getFilter(items)
        if (name === 'true') {
          containsFilter = filter
        } else {
          notContainFilter = filter
        }
      })
      result.tenderSearchParam.containsFilter = containsFilter
      result.tenderSearchParam.notContainFilter = notContainFilter

      if (!Object.keys(containsFilter).length && !Object.keys(notContainFilter).length) {
        result.tenderSearchParam.queryMergeType = 'AND'
      } else {
        result.tenderSearchParam.queryMergeType = mode ? 'AND' : 'OR'
      }

      this.$emit('update:filters', result)
    },
    removeSharp(value) {
      this.phrase = value.replace(/^#|#$/g, '')
    },
    updatePhrase() {
      const result = this.$_.cloneDeep(this.filters)
      result.tenderSearchParam.phrase = this.phrase
      this.$emit('update:filters', result)
    },
  },
  computed: {
    ...mapGetters({
      availableOrganizations: 'getAvailableOrganizations',
    }),
    flatFilters() {
      return {
        additionalFilter: this.filters.additionalFilter,
        queryMergeType: this.filters?.tenderSearchParam?.queryMergeType || 'AMD',
        sort: this.filters.sort,
        ...this.filters.tenderSearchParam
      }
    },
    filter_items() {
      let filters = this.types
      filters.forEach(el => el.text = this.bigFirstLetter(el.text))
      return filters.map((el, index) => ({
        id: el.value,
        title: el.text,
        contain: true,
        index,
        search: [],
        type: el.type,
      }))
    },
    types() {
      let res = this.allHeaders.filter(el => el.setFilter)
      res.push({
        text: this.$t('Tenders.Manager'),
        contain: true,
        type: 'contactIds',
        value: 'manager',
        search: [],
        id: res.length
      })
      if (this.availableOrganizations?.length > 1) {
        res.push({
          text: this.$t('Common.Organization'),
          contain: true,
          type: 'organizationIds',
          value: 'organizations',
          search: [],
          id: res.length
        })
      }
      if (this.mixin_isGodMode) {
        res.push({
          text: this.$t('Common.personalManager'),
          contain: true,
          type: 'tariffUserIds',
          value: 'personalManagers',
          search: [],
          id: res.length
        })
      }
      return res
    },
    tableModeComputed: {
      get() {
        return this.tableMode
      },
      set(value) {
        this.$emit('update:tableMode', value)
      }
    },
  },
  watch: {
    'filters.tenderSearchParam.phrase': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.phrase = newValue
        }
      }
    }
  },
  props: {
    items: Array,
    /**
     * Количество тендеров по фильтру
     */
    itemCount: Number,
    allHeaders: Array,
    tableMode: Boolean,
    /**
     * Фильтры
     */
    filters: Object,
    loading: Boolean
  },
  components: {
    SearchInput,
    ModeButtons,
    TenderFiters,
    FiltersBlockTenders,
    DownloadTendersToExcel,
    OrganizationReportsDialog
  }
}
</script>
<style scoped>
.tenders-toolbar-filter {
  display: flex;
  gap: 5px;
  flex: 1 1 auto;
  justify-content: flex-end !important;
  align-items: center !important;
}
</style>
